import React, { useState, useMemo, useRef } from 'react';

import { Button, Popover, Table, TableBody, TableRow, TableCell, TableHead } from '@mui/material';
import FilterIcon from '@mui/icons-material/FilterList';

import Filters from '../../../common/Filters';
import Search from '../../../common/Search';
import Node from '../../../common/Node';

import InviteRow from './InviteRow';

const MemoizedInviteRow = React.memo(InviteRow);

const PersonalInviteTab = ({
  classes,
  nodesData,
  createInvite, 
  accountsTbox,
  setup_accounts,
  sendInvitation,
  privateInvites,
  onEnableInvite,
  deleteInvitation,
  allSetupAccounts,
  addNodeToNodesData,
}) => {
  const [showFiltersPopover, setShowFiltersPopover] = useState(false);
  const [inviteInputValue, setinviteInputValue] = useState('');
  const [selectedRole, setSelectedRole] = useState(null);
  const [filter, setFilter] = useState(null);

  const onChooseRoleClick = (role) => {
    setSelectedRole(role);
  };

  const onRemoveRoleClick = () => {
    setSelectedRole(null);
  };

  const onInviteInputChange = (inviteInputValue) => {
    setinviteInputValue(inviteInputValue);
  };

  const filterBtnRef = useRef(null);

  const setFiltersToState = (filters) => {
    setFilter(filters);
  };

  const inviteRows = useMemo(() => (
    privateInvites.map((invite, index) => (
      <MemoizedInviteRow
        key={invite.id}
        index={index}
        invite={invite}
        classes={classes}
        nodesData={nodesData}
        setup_accounts={setup_accounts}
        addNodeToNodesData={addNodeToNodesData}
        accountsTbox={accountsTbox}
        onEnableInvite={onEnableInvite}
        sendInvitation={sendInvitation}
        deleteInvitation={deleteInvitation}
      />
    ))
  ), [privateInvites, classes, nodesData, setup_accounts, addNodeToNodesData, accountsTbox, onEnableInvite, sendInvitation, deleteInvitation]);

  return (
    <div>
      <div className={classes.inviteContainer}>
        <div className={`${classes.alignCenter} ${classes.ml20}`}>
          <div style={{ alignSelf: 'center', marginRight: '10px' }}>
            <span className={`${classes.columnHeadingGeneral} ${classes.mb10}`}>Invite by email</span>
            <div className={`${classes.mt5} ${classes.mb5}`}>
              <input
                value={inviteInputValue}
                className={`${classes.input}`}
                style={{ width: '400px' }}
                placeholder="Email"
                onChange={(e) => onInviteInputChange(e.target.value)}
              />
            </div>
          </div>

          {allSetupAccounts && allSetupAccounts.length ?
            <div style={{alignSelf: 'center', marginRight: '20px'}}>
              <span className={`${classes.columnHeadingGeneral} ${classes.mb10}`}>Role</span>
              <div className={`${classes.mt5} ${classes.mb5}`}>
                {selectedRole ? (
                  <Node
                    isLink
                    size="sm"
                    isRemovable
                    node={selectedRole}
                    onRemoveClick={onRemoveRoleClick}
                  />
                ) : (
                  <Search
                    predefinedResults={allSetupAccounts}
                    containerStyles={{
                      height: 24,
                    }}
                    onDropdownElementClick={({ node }) => {
                      onChooseRoleClick(node);
                    }}
                  />
                )}
              </div>
            </div>
          : null}

          {selectedRole ?
          <React.Fragment>
            <div
              ref={filterBtnRef}
              style={{ alignSelf: 'center' }}
            >
              <span className={`${classes.columnHeadingGeneral} ${classes.mb10}`}>Pre state</span>
                <div className={`${classes.mt5} ${classes.mb5}`}></div>
                <FilterIcon
                  style={filter && filter.length
                    ? { background: '#D6E5FF', borderRadius: '3px', color: '#4c4c4c', cursor: 'pointer' }
                    : { color: '#878787', cursor: 'pointer' }
                  }
                  onClick={(e) => setShowFiltersPopover(true)}
                />
            </div>

            <Popover
              id={`filters-popover-personal`}
              anchorEl={filterBtnRef.current}
              open={showFiltersPopover}
              onClose={() => setShowFiltersPopover(false)}
              PaperProps={{
                style: {
                  marginTop: '10px',
                  overflow: 'visible',
                  boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
                },
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <Filters
                mode='edit'
                defaultBg={true}
                ancestor={selectedRole.id}
                filterByNodeTitle={false}
                callbacks={{
                  setFiltersToParentState: setFiltersToState,
                  onFiltersSearchNodeCb: addNodeToNodesData,
                }}
                useChain
                loaded={true}
                notEditableGraphTrigger
                nodes={nodesData}
                graphTriggerAncestor={selectedRole}
                initialFilters={filter}
              />
            </Popover>
          </React.Fragment>
          : null}

          <div style={{alignSelf: 'center', marginTop: '17px'}}>
            <Button
              size="small"
              disabled={!inviteInputValue || !selectedRole}
              onClick={(() => {
                createInvite(selectedRole, inviteInputValue, filter, (status) => {
                  if (status === 'ok') {
                    setinviteInputValue('');
                    setSelectedRole(null);
                    setFilter(null);
                  }
                });
                }
              )}
              className={`${classes.btn} ${classes.btnNormal} ${classes.inviteBtn}`}
            >
              Create invitation
            </Button>
          </div>
        </div>
      </div>

      {privateInvites.length ?
        <div
          style={{
            padding: '20px 40px',
            marginBottom: '200px'
          }}
        >
          <Table className={`${classes.mr10} ${classes.mb5} ${classes.table}`}>
            <TableHead>
              <TableRow>
                <TableCell className={`${classes.columnHeadingGeneral} ${classes.tableCell}`}>Enabled</TableCell>
                <TableCell className={classes.columnHeadingGeneral}>Role</TableCell>
                <TableCell className={classes.columnHeadingGeneral}>Node</TableCell>
                <TableCell className={classes.columnHeadingGeneral}>Email</TableCell>
                <TableCell className={`${classes.columnHeadingGeneral} ${classes.nowrap}`}>Pre state</TableCell>
                <TableCell className={`${classes.columnHeadingGeneral} ${classes.nowrap}`}>Invitation code</TableCell>
                <TableCell className={classes.columnHeadingGeneral}>Creation time</TableCell>
                <TableCell className={classes.columnHeadingGeneral}/>
              </TableRow>
            </TableHead>

            <TableBody>
              {inviteRows}
            </TableBody>
          </Table>
        </div>
      : null}
    </div>
  );
};

export default PersonalInviteTab;
